<template>
  <v-container>
    <v-card flat class="administrator">
      <account-settings
        :accountData="student"
        :onClick="resetPassword"
        :onClicked="deleteUser"
      />
    </v-card>
  </v-container>
</template>

<script>
import AccountSettings from "../../../Setting/components/Account/AccountSettings.vue";
export default {
  name: "StudentCard",
  components: { AccountSettings },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Administrator/getStudent", {
        reg: to.params.reg,
      });
    });
  },
  data() {
    return {};
  },
  computed: {
    student() {
      return this.$store.getters["Administrator/administratorGetters"](
        "student",
      )["profile"];
    },
  },
  methods: {
    resetPassword(formData) {
      this.$store.dispatch("Auth/forgotPassword", { ...formData });
    },
    deleteUser(id) {
      this.$confirm.show({
        title: `Delete Student`,
        text: `Are you sure you want to delete student with name '${this.student.firstName} ${this.student.lastName}'. It cannot be undone`,
        onConfirm: () => {
          this.$store.dispatch("Administrator/deleteStudent", { id });
          this.$router.back();
        },
      });
    },
    decode(value) {
      return atob(JSON.parse(value));
    },
  },
};
</script>

<style scoped>
@import url("../../styles/administrator.css");
</style>
